import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { ConfirmInboundDeliveryDateMutation } from "../../../graphql/deliveryService/mutations/confirmInboundDeliveryDate";
import { handleError } from "../../../utils/graphqlHelper";

interface ConfirmInboundDeliveryDateMutationProps {
  dataAction: (id: string) => void;
  errorAction?: () => void;
}

const useConfirmInboundDeliveryDateMutation = (
  props: ConfirmInboundDeliveryDateMutationProps,
) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const mutation = useMutation(ConfirmInboundDeliveryDateMutation, {
    update: (cache, result) => {
      const data =
        result.data?.confirmInboundDeliveryDate.inboundDeliveryDetail;
      if (!data) return;

      const cacheId = cache.identify({
        __typename: "InboundDeliveryDetail",
        id: data.id,
      });
      cache.evict({ id: cacheId });
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const confirmedQuantityOutput =
    data?.confirmInboundDeliveryDate.inboundDeliveryDetail;

  useEffect(() => {
    if (!error) return;

    handleError(
      t("confirmInboundDeliveryDateError"),
      error.message,
      errorAction,
    );
  }, [error]);

  useEffect(() => {
    if (!data || !confirmedQuantityOutput) return;

    dataAction(confirmedQuantityOutput.id);
  }, [data]);

  return mutation;
};

export default useConfirmInboundDeliveryDateMutation;
